module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-star-full-ee1eb7ca095cd57c86fc4d36b760a27c.png";